import RemoveVariablesModal from './RemoveVariablesModal';

export default RemoveVariablesModal;